



































import { Vue, Component } from 'vue-property-decorator';
import { IRoute } from './api/routes';

/**
 * Check if the current browser is running on Android
 */
function isAndroid(): boolean {
  return !!navigator.userAgent.match(/Android/i);
}

@Component
export default class App extends Vue {
  // List of available routes
  routes: IRoute[] = [];

  // Whether or not we are running on Android
  isAndroid: boolean = isAndroid();

  /**
   * Vue Lifecycle Method
   */
  async created() {
    // Get the list of routes
    this.routes = await this.$api.Routes.getAll();

    // If no route was specified, go to the first route provided
    if (!this.$route.params.routeId) {
      this.$router.push({ name: 'route', params: { routeId: this.routes[0].id } });
    }
  }
}
